$(function () {
  // ハンバーガーボタン
  $("#hamburger").click(function () {
    $("#top").toggleClass("cross-top");
    $("#middle").toggleClass("cross-middle");
    $("#bottom").toggleClass("cross-bottom");
    $('#slide').toggleClass('show');
    $('body, html').toggleClass("slide__none");
  });

  $('.aside__item--head').click(function () {
    $(this).next('.aside__item--contents').slideToggle();
  });

  var arySpinnerCtrl = [];
  var spin_speed = 20; //変動スピード

  //長押し押下時
  $('.btnspinner').on('touchstart mousedown click', function (e) {
    if (arySpinnerCtrl['interval']) return false;
    var target = $(this).data('target');
    arySpinnerCtrl['target'] = target;
    arySpinnerCtrl['timestamp'] = e.timeStamp;
    arySpinnerCtrl['cal'] = Number($(this).data('cal'));
    //クリックは単一の処理に留める
    if (e.type == 'click') {
      spinnerCal();
      arySpinnerCtrl = [];
      return false;
    }
    //長押し時の処理
    setTimeout(function () {
      //インターバル未実行中 + 長押しのイベントタイプスタンプ一致時に計算処理
      if (!arySpinnerCtrl['interval'] && arySpinnerCtrl['timestamp'] == e.timeStamp) {
        arySpinnerCtrl['interval'] = setInterval(spinnerCal, spin_speed);
      }
    }, 500);
  });

  //長押し解除時 画面スクロールも解除に含む
  $(document).on('touchend mouseup scroll', function (e) {
    if (arySpinnerCtrl['interval']) {
      clearInterval(arySpinnerCtrl['interval']);
      arySpinnerCtrl = [];
    }
  });

  //変動計算関数
  function spinnerCal() {
    var target = $(arySpinnerCtrl['target']);
    var num = Number(target.val());
    num = num + arySpinnerCtrl['cal'];
    if (num > Number(target.data('max'))) {
      target.val(Number(target.data('max')));
    } else if (Number(target.data('min')) > num) {
      target.val(Number(target.data('min')));
    } else {
      target.val(num);
    }
  }
  if ($('.goods').length) {
    $('.goods').parent().css('width', '100%');
    $('.goods').show();
    $('.goods__price').eq(0).show();
    $('.goods__btn').eq(0).show();
    $('#price-0').show();
    $('select').change(function () {
      var val = $(this).val();
      $('.goods__price').hide();
      $('.goods__btn').hide();
      $('#price-' + val).show();
      $('#quantity-' + val).show();
      if ($(this).val() == '0') {
        $('.goods__btn').addClass('hide');
      } else {
        $('.goods__btn').removeClass('hide');
      }
      $(".goods__btn").attr("href", "/cart/add?id=" + val + "&quantity=1");
      $(".btn-en").attr("href", "/en/cart/add?id=" + val + "&quantity=1");
      $(".btn").attr("href", "/en/cart/add?id=" + val + "&quantity=1");
    });

    $('.jp-en').each(function () {
      itemName = $(this).text().split('／', 1);
      $(this).text(itemName);
    });
  }

  if ($('.mainte').length) {
    $('.mainte__faq--q').click(function () {
      if ($(this).next('.mainte__faq--a').hasClass('current')) {
        $(this).next('.mainte__faq--a').slideToggle().removeClass('current');
        $(this).find('.mainte__faq--arrow').removeClass('rotate');
      } else {
        $(this).find('.mainte__faq--arrow').addClass('rotate');
        $(this).next('.mainte__faq--a').slideToggle().addClass('current').css('display', 'flex');
      }
    })
  }


  if ($('#cart').length) {
    $('#cart').parent().css('width', '100%');
    $('#cart').show();
    if ($(window).width() < 767) {
      $('.pc').remove();
    } else {
      $('.sp').remove();
    }
    $('.jp-en').each(function () {
      itemName = $(this).text().split('／', 1);
      $(this).text(itemName);
    });
  }


  if ($('#collection').length) {
    $('#collection').parent().css('width', '100%');
    $('#collection').show();

    $('.jp-en').each(function () {
      itemName = $(this).find('.collection__item--name').text().split('／', 1);
      $(this).find('.collection__item--name').text(itemName);
    });
  }

  if ($('#collection-select').length) {
    var search = location.search.split('&', 2);
    console.log(search[0] + '&' + search[1]);
    $('#collection-select').change(function () {
      if (search[0].indexOf('?type') != -1) {
        console.log(search[0] + '&' + search[1] + '&sort_by=' + $(this).find('option:selected').val());
        window.location.search = search[0] + '&' + search[1] + '&sort_by=' + $(this).find('option:selected').val();
      } else {
        window.location.search = 'sort_by=' + $(this).find('option:selected').val();
      }

    });
    if (window.location.search.indexOf('sort_by=created-descending') != -1) {
      $('option[value="created-descending"]').prop('selected', true);
    }
    if (window.location.search.indexOf('sort_by=best-selling') != -1) {
      $('option[value="best-selling"]').prop('selected', true);
    }
    if (window.location.search.indexOf('sort_by=price-ascending') != -1) {
      $('option[value="price-ascending"]').prop('selected', true);
    }
    if (window.location.search.indexOf('sort_by=price-descending') != -1) {
      $('option[value="price-descending"]').prop('selected', true);
    }
  }


  $('#movie-click').click(function () {
    $('#modal').show();
  });
  $('#modal-ar-click').click(function () {
    console.log('.test');
    $('#modal-ar').show();
  });

  $('#close').click(function () {
    $(this).parents('#modal').hide();
  });
  $('#close-ar').click(function () {
    $(this).parents('#modal-ar').hide();
  });
  $('#top-close').click(function () {
    $(this).parents('#top-modal').hide();
  });



  $(".register__submit").prop('disabled', true);
  if ($('#register').length) {
    $('input, select, textarea').change(function () {
      if (
        $('input[name="customer[last_name]').val() === "" ||
        $('input[name="customer[first_name]').val() === "" ||
        $('input[name="customer[note][カナ/姓]').val() === "" ||
        $('input[name="customer[note][カナ/名]').val() === "" ||
        $('input[name="customer[email]').val() === "" ||
        $('input[name="mail-confirm').val() === "" ||
        $('input[name="customer[password]').val() === "" ||
        $('input[name="password-confirm').val() === "" ||
        $('input[name="customer[accepts_marketing]').val() === "" ||
        $('input[name="customer[note][誕生日:年]').val() === "" ||
        $('input[name="customer[note][誕生日:月]').val() === "" ||
        $('input[name="customer[note][誕生日:日]').val() === "" ||
        $('input[name="privacy').val() === ""
      ) {
        $(".register__submit").prop('disabled', true);
        $(".contact__var--text").show();
      } else {
        if ($('input[name="customer[email]').val() !== $('input[name="mail-confirm').val()) {
          $('.mail-not-equal').show();
          $(".contact__var--text").show();
          $(".register__submit").prop('disabled', true);
        } else if ($('input[name="customer[password]').val() !== $('input[name="password-confirm').val()) {
          $('.pass-not-equal').show();
          $(".contact__var--text").show();
          $(".register__submit").prop('disabled', true);
        } else {
          $('.mail-not-equal').hide();
          $('.pass-not-equal').hide();
          $(".register__submit").prop('disabled', false);
          $(".contact__var--text").hide();
        }
      }
    });
  }

  var sort = location.search;
  // console.log(sort);
  if (sort.indexOf("sort_by=created-descending") != -1) {
    $('.collection__search--item').removeClass('current');
    $('input[value="New Arrivals"]').addClass('current');
    $('input[value="新着順"]').addClass('current');
  }
  if (sort.indexOf("sort_by=best-selling") != -1) {
    $('.collection__search--item').removeClass('current');
    $('input[value="Recommended"]').addClass('current');
    $('input[value="おすすめ順"]').addClass('current');
  }
  if (sort.indexOf("sort_by=price-ascending") != -1) {
    $('.collection__search--item').removeClass('current');
    $('input[value="Cheapest First"]').addClass('current');
    $('input[value="安い順"]').addClass('current');
  }
  if (sort.indexOf("sort_by=price-descending") != -1) {
    $('.collection__search--item').removeClass('current');
    $('input[value="Highest to Lowest"]').addClass('current');
    $('input[value="高い順"]').addClass('current');
  }
  if (sort == "") {
    $('.collection__search--item').removeClass('current');
    $('input[value="New Arrivals"]').addClass('current');
    $('input[value="新着順"]').addClass('current');
  }
  $('.slide__search').click(function () {
    $(this).find('.header__input').attr('placeholder', '');
  });

  if ($('#collection').length) {
    var title = $('#collection__span').html();
    var reTitle = title.replace('-', '<br>');
    $('#collection__span').html(reTitle);
  }
});
$(window).on('load', function () {
  function startRemove() {
    price = setInterval(function () {
      $('.js-price').each(function () {
        var num = $(this).text();
        var strNum = Number(num) / 100;
        if ($('#en').length) {
          $(this).html('¥' + Number(strNum).toLocaleString() + '<br>（Tax included）');
        } else {
          $(this).html('¥' + Number(strNum).toLocaleString() + '(税込)');
        }

        itemName = $(this).prev('.collection__item--name').text().split('／', 1);
        $(this).prev('.collection__item--name').text(itemName);
        // console.log(strNum);
      });
      if ($('#en').length) {
        var dir1 = $('#recently-viewed-products').children().eq(0).prop('id');
        var dir2 = $('#recently-viewed-products').children().eq(1).prop('id');
        var dir3 = $('#recently-viewed-products').children().eq(2).prop('id');
        console.log(dir1);
        console.log(dir2);
        console.log(dir3);
        if (dir1.indexOf('jp-en') != -1) {
          $('#' + dir1).find('.collection__item--name').text($('.' + dir1).text());
          $('#' + dir1).find('.collection__item').attr('href', 'https://miyabun.shop/en/products/' + dir1);
        } else {
          $('#' + dir1).hide();
        }
        if (dir2.indexOf('jp-en') != -1) {
          $('#' + dir2).find('.collection__item--name').text($('.' + dir2).text());
          $('#' + dir2).find('.collection__item').attr('href', 'https://miyabun.shop/en/products/' + dir2);
        } else {
          $('#' + dir2).hide();
        }
        if (dir3.indexOf('jp-en') != -1) {
          $('#' + dir3).find('.collection__item--name').text($('.' + dir3).text());
          $('#' + dir3).find('.collection__item').attr('href', 'https://miyabun.shop/en/products/' + dir3);
        } else {
          $('#' + dir3).hide();
        }
      }
    }, 1000);
  }
  function stopRemove() {
    clearInterval(price);
  }
  startRemove();
  setTimeout(function () {
    stopRemove();
    // console.log('test');
  }, 1000);

  if (document.querySelectorAll('.cart__table--name').length) {
    let cartCount = 0
    let sharpen = false;

    document.querySelectorAll('.cart__table--name').forEach(element => {
      if (element.textContent.indexOf('包丁研ぎ') > -1) {
        cartCount++;
        sharpen = true;
      }
    });

    if (sharpen) {
      document.getElementById('cart').classList.add('mixed')
    }

    if (document.querySelectorAll('.cart__table--name').length === cartCount) {
      document.getElementById('cart').classList.add('only')
    }
  }
});

